import { Link } from "react-router-dom";
import { imgUrl } from "@/lib/api";

/**
 * SoldThumb — image-only thumbnail used inside the Browse "Recently Sold"
 * strip. Intentionally shows NO title, NO price, NO buyer/seller — just
 * the card face — so recent-sale flow is visible while the parties on
 * both sides of the trade stay anonymous.
 *
 * Still links to the underlying listing so members can click through to
 * see what the card actually is (that page is public info anyway).
 */
export default function SoldThumb({ item }) {
  const img = imgUrl(item.front_image, { w: 200 });
  return (
    <Link
      to={`/listing/${item.listing_id}`}
      data-testid={`sold-thumb-${item.listing_id}`}
      className="group h57-surface h57-surface-hover block transition-transform duration-150 hover:-translate-y-0.5"
    >
      <div className="aspect-square bg-[#0A0A0A] relative overflow-hidden">
        {img ? (
          <img
            src={img}
            alt="Recently sold card"
            className="w-full h-full object-contain"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-mono text-[8px] text-zinc-700 tracking-widest">
            NO IMG
          </div>
        )}
      </div>
    </Link>
  );
}
